<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>广州睿眼进销存</el-breadcrumb-item>
      <el-breadcrumb-item>销售</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <el-row :gutter="24" v-if="SubRule_NaoxjStockSale_Add">
          <el-col :span="12">
            <el-card class="box-card">
              <div class="card_title">创建订单</div>
              <el-form :model="addForm" ref="addFormRef" label-width="130px">
                <el-form-item label="选择产品" class="addAdminFormLong">
                  <div class="productdata1">
                    <div class="productdata2">
                      <el-select v-model="addForm.name" @change="changeName" placeholder="产品" style="width: 20%" class="rengongdata3">
                        <el-option
                          v-for="item in nameList" :key="item.Name" :label="item.Name" :value="item.Name">
                        </el-option>
                      </el-select>
                      <el-select v-model="addForm.beizhuout" placeholder="出货备注" style="width: 20%" class="rengongdata3">
                        <el-option
                          v-for="item in beizhuoutList" :key="item.Beizhuout" :label="item.Beizhuout" :value="item.Beizhuout">
                        </el-option>
                      </el-select>
                      下单数量:
                      <el-input v-model="addForm.num" placeholder="数量" style="width: 16%"></el-input>
                      <el-button type="text" @click="clickaddproduct()">增加</el-button>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="已选产品" class="addAdminFormLong">
                  <div class="productdata1">
                    <div class="productdata2" v-for="rgitem in addForm.productList" :key="rgitem.index">
                      <el-select v-model="rgitem.name" placeholder="请选择产品" style="width: 20%" class="rengongdata3" :disabled="true">
                        <el-option
                          v-for="item in nameList" :key="item.Name" :label="item.Name" :value="item.Name">
                        </el-option>
                      </el-select>
                      <el-select v-model="rgitem.beizhuout" placeholder="进货备注" style="width: 20%" class="rengongdata3" :disabled="true">
                        <el-option
                          v-for="item in beizhuoutList" :key="item.Beizhuout" :label="item.Beizhuout" :value="item.Beizhuout">
                        </el-option>
                      </el-select>
                      单价:
                      <el-input v-model="rgitem.money" placeholder="单价" :disabled="true" style="width: 16%"></el-input>
                      数量:
                      <el-input v-model="rgitem.num" placeholder="数量" :disabled="true" style="width: 16%"></el-input>
                      价格:
                      <el-input v-model="rgitem.moneytotal" placeholder="自动计算价格" :disabled="true" style="width: 16%"></el-input>
                      <el-button type="text" @click="clickdeleteproduct(rgitem)">删除</el-button>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="总金额" class="addAdminForm">
                  <el-input v-model="addForm.moneytotal" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="收件姓名" class="addAdminForm">
                  <el-input v-model="addForm.recvname" placeholder="请输入收件人姓名"></el-input>
                </el-form-item>
                <el-form-item label="收件手机" class="addAdminForm">
                  <el-input v-model="addForm.phone" placeholder="请输入收件人手机"></el-input>
                </el-form-item>
                <el-form-item label="收件地址" class="addAdminForm">
                  <el-input v-model="addForm.address" placeholder="请输入收件人地址"></el-input>
                </el-form-item>
                <el-form-item label="销售员" class="addAdminForm">
                  <el-input v-model="addForm.salesperson" placeholder="请输入销售员"></el-input>
                </el-form-item>
                <el-form-item label="备注" class="addAdminForm">
                  <el-input v-model="addForm.beizhu" placeholder="请输入备注(可选)"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="clickadd">添加</el-button>
                </el-form-item>
              </el-form>
            </el-card>
          </el-col>
        </el-row>

        <el-card class="box-card">
          <div class="card_title">订单明细</div>
          <!-- 筛选条件 start -->
          <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
            <el-form-item label="">
              <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入订单号"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="keywords.orderstatus" placeholder="请选择" class="select">
                <el-option label="请选择订单状态" value="-2"></el-option>
                <el-option label="待财务确认收款" value="-1"></el-option>
                <el-option label="待发货" value="0"></el-option>
                <el-option label="已部分发货" value="1"></el-option>
                <el-option label="已全部发货" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="keywords.recvname" @keyup.enter.native="clicksearch" placeholder="请输入收件人姓名"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="keywords.sn" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="clicksearch">查询</el-button>
              <el-button type="success" @click="clickexcel()">导出</el-button>
            </el-form-item>
          </el-form>
          <!-- 筛选条件 end -->

          <!-- 数据列表 start -->
          <el-table v-loading="loading" :data="dataList" ref="dataList" border stripe>
            <el-table-column type="expand" min-width="1%">
              <template slot-scope="props">
                <el-table :data="props.row.Sublist" height="200" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
                  <el-table-column label="产品名称"  prop="Name"></el-table-column>
                  <el-table-column label="出货备注"  prop="Beizhuout"></el-table-column>
                  <el-table-column label="订单数量" prop="Num"></el-table-column>
                  <el-table-column label="已发货数量" prop="Numsend"></el-table-column>
                  <el-table-column label="单价" prop="Money" v-if="SubRule_NaoxjStockSale_Jiage"></el-table-column>
                  <el-table-column label="总价" prop="Moneytotal" v-if="SubRule_NaoxjStockSale_Jiage"></el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column prop="Orderid" label="订单号" min-width="10%"></el-table-column>
            <el-table-column prop="OrderstatusName" label="订单状态" min-width="6%">
              <template slot-scope="props">
                <span class="blue" style="margin-left: 0; margin-right: 5px;color: #48c9b0;" @click="toogleExpand(props.row)">{{props.row.OrderstatusName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Moneytotal" label="总价" min-width="6%" v-if="SubRule_NaoxjStockSale_Jiage"></el-table-column>
            <el-table-column prop="Recvname" label="收件人姓名" min-width="7%"></el-table-column>
            <el-table-column prop="Phone" label="收件人手机" min-width="7%"></el-table-column>
            <el-table-column prop="Address" label="收件人地址" min-width="9%"></el-table-column>
            <el-table-column prop="Kehuname" label="客户名称" min-width="9%"></el-table-column>
            <el-table-column prop="Salesperson" label="销售员" min-width="9%"></el-table-column>
            <el-table-column prop="Sn" label="保修卡号" min-width="11%"></el-table-column>
            <el-table-column prop="Beizhu" label="备注" min-width="11%"></el-table-column>
            <el-table-column prop="Createtime" label="创建时间" min-width="7%"></el-table-column>
            <el-table-column prop="operation" label="操作" min-width="8%">
              <template v-slot="scope">
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Orderstatus == -1 && SubRule_NaoxjStockSale_Delete" @click="clickdelete(scope.row)">删除</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Orderstatus == -1 && SubRule_NaoxjStockSale_Add" @click="clickedit(scope.row)">编辑</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Orderstatus == -1 && SubRule_NaoxjStockSale_CaiWuShenPi" @click="clickCaiWuShenPi(scope.row)">财务确认收款</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Orderstatus >= 0 && SubRule_NaoxjStockSale_Delivery" @click="clickwuliu(scope.row)">发货管理</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Orderstatus >= 1 && SubRule_NaoxjStockSale_DeliveryRecord" @click="clickDeliveryRecord(scope.row)">发货记录</el-button>
                <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clicksn(scope.row)">填写SN和客户名</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 数据列表 end -->
          <!-- 分页 -->
          <div class="pages">
            <el-pagination
              @current-change="handleCurrentPageChange"
              :page-size="10"
              layout="total, prev, pager, next, jumper"
              :total="dataListnum"
              :current-page.sync="selectedPageNo">
            </el-pagination>
          </div>
        </el-card>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <el-tab-pane label="编辑" name="five" disabled="disabled">
      <NaoxjStockSaleEdit ref="SubVuefive" v-on:triggerFunc="BackToFirst(1)"></NaoxjStockSaleEdit>
    </el-tab-pane>

    <el-tab-pane label="发货管理" name="three" disabled="disabled">
      <NaoxjStockSaleSend ref="SubVuethree" v-on:triggerFunc="BackToFirst(1)"></NaoxjStockSaleSend>
    </el-tab-pane>

    <el-tab-pane label="发货记录" name="six" disabled="disabled">
      <NaoxjStockSaleSendLog ref="SubVuesix" v-on:triggerFunc="BackToFirst(0)"></NaoxjStockSaleSendLog>
    </el-tab-pane>

    <el-tab-pane label="填写保修卡号" name="seven" disabled="disabled">
      <NaoxjStockSaleEditSn ref="SubVueseven" v-on:triggerFunc="BackToFirst(1)"></NaoxjStockSaleEditSn>
    </el-tab-pane>

  </el-tabs>
  </div>
</template>

<script>
import NaoxjStockSaleSend from '@/componentsSubVue/NaoxjStockSaleSend.vue'
import NaoxjStockSaleSendLog from '@/componentsSubVue/NaoxjStockSaleSendLog.vue'
import NaoxjStockSaleEdit from '@/componentsSubVue/NaoxjStockSaleEdit.vue'
import NaoxjStockSaleEditSn from '@/componentsSubVue/NaoxjStockSaleEditSn.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    NaoxjStockSaleSend,
    NaoxjStockSaleSendLog,
    NaoxjStockSaleEdit,
    NaoxjStockSaleEditSn
  },
  name: 'MyNaoxjStockSale',
  data () {
    return {
      loading: false,
      activeName: 'first',
      nameList: [],
      beizhuoutList: [],
      addForm: {
        name: '',
        beizhuout: '',
        num: '',
        productList: [],
        danjia: '',
        moneytotal: '',
        recvname: '',
        phone: '',
        address: '',
        salesperson: '',
        beizhu: ''
      },
      // 查询
      keywords: {
        orderid: '',
        orderstatus: '-2',
        recvname: '',
        sn: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      SubRule_NaoxjStockSale_Add: false,
      SubRule_NaoxjStockSale_CaiWuShenPi: false,
      SubRule_NaoxjStockSale_Delivery: false,
      SubRule_NaoxjStockSale_Jiage: false,
      SubRule_NaoxjStockSale_Delete: false,
      SubRule_NaoxjStockSale_DeliveryRecord: false,
      rowToogle: null
    }
  },
  mounted () {
    this.apiGetNaoxjStockSalenum()
    this.apiGetNaoxjStockSalelist()
    this.apiGetNaoxjStockCatalogNameList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_NaoxjStockSale_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_NaoxjStockSale_Add = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_NaoxjStockSale_CaiWuShenPi', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_NaoxjStockSale_CaiWuShenPi = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_NaoxjStockSale_Delivery', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_NaoxjStockSale_Delivery = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_NaoxjStockSale_Jiage', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_NaoxjStockSale_Jiage = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_NaoxjStockSale_Delete', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_NaoxjStockSale_Delete = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_NaoxjStockSale_DeliveryRecord', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_NaoxjStockSale_DeliveryRecord = true
      }
    })
  },
  methods: {
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    changeName() {
      this.addForm.beizhuout = ''
      this.apiGetNaoxjStockCatalogBeizhuoutList()
    },
    BackToFirst (val) {
      this.activeName = 'first'
      if (val === 1) {
        this.apiGetNaoxjStockSalenum()
        this.apiGetNaoxjStockSalelist()
      }
    },
    toogleExpand (row) {
      const $table = this.$refs.dataList
      this.dataList.map((item) => {
        if (row.Id !== item.Id) {
          $table.toggleRowExpansion(item, false)
        }
      })
      $table.toggleRowExpansion(row)
      this.rowToogle = row
    },
    toogleExpandManual (row) {
      const $table = this.$refs.dataList
      this.dataList.map((item) => {
        if (row.Id == item.Id) {
          $table.toggleRowExpansion(item, true)
        }
      })
    },
    clickexcel () {
      this.apiExcelNaoxjStockSale()
    },
    // 编辑管理
    clickedit (row) {
      this.activeName = 'five'
      this.$refs.SubVuefive.LoadData({ name: '', params: { orderid: row.Orderid, jigouid: row.Jigouid, recvname: row.Recvname, phone: row.Phone, address: row.Address, salesperson: row.Salesperson, beizhu: row.Beizhu } })
    },
    // 财务确认收款
    clickCaiWuShenPi(row) {
      this.$confirm('是否确认收款?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiCaiWuShenPiNaoxjStockSale(row.Id)
      })
    },
    // 发货管理
    clickwuliu (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData({ name: '', params: { orderid: row.Orderid} })
    },
    // 发货记录
    clickDeliveryRecord (row) {
      this.activeName = 'six'
      this.$refs.SubVuesix.LoadData({ name: '', params: { orderid: row.Orderid } })
    },
    //填写保修卡号
    clicksn(row){
      this.activeName = 'seven'
      this.$refs.SubVueseven.LoadData(row)
    },
    clickaddproduct () {
      if (this.addForm.name == '') {
        Vue.prototype.FunAlertMsg('请选择产品')
        return
      }
      if (this.addForm.beizhuout == '') {
        Vue.prototype.FunAlertMsg('请选择出货备注')
        return
      }
      if (this.addForm.num == '') {
        Vue.prototype.FunAlertMsg('请输入数量')
        return
      }
      this.apiGetNaoxjStockSaleJiaGe()
    },
    runaddproduct (danjia,beizhuout, num) {
      danjia = Number(danjia)
      num = Number(num)
      var moneytotal = danjia * num
      moneytotal = +moneytotal.toFixed(2)
      var isfind = false
      // 先判断是否需要合并到已有的产品里
      for (var j = 0, len = this.addForm.productList.length; j < len; j++) {
        if (this.addForm.productList[j].name === this.addForm.name && this.addForm.productList[j].beizhuout === this.addForm.beizhuout) {
          isfind = true
          this.addForm.productList[j].num = this.addForm.productList[j].num + num
          this.addForm.productList[j].money = danjia
          var moneytotalbuf = danjia * this.addForm.productList[j].num
          moneytotalbuf = +moneytotalbuf.toFixed(2)
          this.addForm.productList[j].moneytotal = moneytotalbuf
        }
      }
      // 如果没有，就新增
      if (!isfind) {
        var len2 = this.addForm.productList.length
        var obj2 = { index: len2 + 1, name: this.addForm.name,beizhuout: beizhuout, num: num, money: danjia, moneytotal: moneytotal }
        this.addForm.productList.push(obj2)
      }

      this.UpdateMoneyTotal()
    },
    clickdelete (row) {
      this.$confirm('是否删除此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDeleteNaoxjStockSale(row.Orderid)
      })
    },
    clickdeleteproduct (rgitem) {
      var buflist = []
      var addindex = 0
      for (var j = 0, len = this.addForm.productList.length; j < len; j++) {
        var index = this.addForm.productList[j].index
        if (index === rgitem.index) {
          addindex = -1
        } else {
          var obj = this.addForm.productList[j]
          obj.index += addindex
          buflist.push(obj)
        }
      }
      this.addForm.productList = buflist

      this.UpdateMoneyTotal()
    },
    UpdateMoneyTotal () {
      // 更新总价
      var moneytotal = 0
      for (var j = 0, len = this.addForm.productList.length; j < len; j++) {
        moneytotal += this.addForm.productList[j].moneytotal
        moneytotal = +moneytotal.toFixed(2)
      }
      this.addForm.moneytotal = moneytotal
    },
    clickadd () {
      // if (!this.addForm.moneytotal) {
      //   this.$alert('请输入总价', '提示')
      //   return
      // }
      if (!this.addForm.recvname) {
        this.$alert('请输入收件姓名', '提示')
        return
      }
      if (!this.addForm.phone) {
        this.$alert('请输入收件手机', '提示')
        return
      }
      if (!this.addForm.address) {
        this.$alert('请输入收件地址', '提示')
        return
      }
      if (!this.addForm.salesperson) {
        this.$alert('请输入销售员', '提示')
        return
      }
      this.apiAddNaoxjStockSale()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetNaoxjStockSalenum()
      this.apiGetNaoxjStockSalelist()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetNaoxjStockSalelist()
    },
    apiGetNaoxjStockSaleJiaGe: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.addForm.name,
        beizhuout: that.addForm.beizhuout,
        num: that.addForm.num
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockSaleJiaGe, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.runaddproduct(response.data.Money,that.addForm.beizhuout, response.data.Num)
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetNaoxjStockSalenum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        recvname: that.keywords.recvname,
        sn: that.keywords.sn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockSalenum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetNaoxjStockSalelist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        recvname: that.keywords.recvname,
        sn: that.keywords.sn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockSalelist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiDeleteNaoxjStockSale: function (orderid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteNaoxjStockSale, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetNaoxjStockSalenum()
            that.apiGetNaoxjStockSalelist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddNaoxjStockSale: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productlist: JSON.stringify(this.addForm.productList),
        moneytotal: this.addForm.moneytotal,
        recvname: this.addForm.recvname,
        phone: this.addForm.phone,
        address: this.addForm.address,
        salesperson: this.addForm.salesperson,
        beizhu: this.addForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddNaoxjStockSale, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.addForm.productList = []
            that.addForm.moneytotal = ''
            that.addForm.beizhu = ''

            that.activeName = 'first'
            that.apiGetNaoxjStockSalenum()
            that.apiGetNaoxjStockSalelist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetNaoxjStockCatalogNameList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockCatalogNameList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.nameList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetNaoxjStockCatalogBeizhuoutList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: this.addForm.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockCatalogBeizhuoutList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.beizhuoutList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiCaiWuShenPiNaoxjStockSale: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CaiWuShenPiNaoxjStockSale, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetNaoxjStockSalenum()
            that.apiGetNaoxjStockSalelist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelNaoxjStockSale: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        recvname: that.keywords.recvname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelNaoxjStockSale, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style>
  .el-table .cell {
      white-space: pre-wrap;
  }
</style>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select1 {
    width: 109px;
    margin-right: 15px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

.productdata3 {
  padding-right: 5px;
}

.box-card{
    margin-top: 5px;
    margin-bottom: 20px;
    background: #FFF;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.card_title{
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
}
</style>
